import type { NavigateFunction } from "react-router-dom";
import { routes } from "./routes";

let navigateRef: NavigateFunction | null = null;

export function registerAppNavigation(navigate: NavigateFunction): void {
  navigateRef = navigate;
}

export function unregisterAppNavigation(): void {
  navigateRef = null;
}

/**
 * Prefer React Router navigation so the document does not fully reload (preserves SPA state, toasts, Network tab).
 */
export function navigateToLoginReplace(): void {
  const pathname = window.location.pathname;
  if (
    pathname === routes.login ||
    pathname === routes.homepage ||
    pathname === routes.home ||
    pathname === routes.landing ||
    pathname === routes.properties
  ) {
    return;
  }
  if (navigateRef) {
    navigateRef(routes.login, { replace: true });
    return;
  }
  window.location.assign(routes.login);
}
